import { render, staticRenderFns } from "./PackageTypes.vue?vue&type=template&id=98e9d204&scoped=true&"
import script from "./PackageTypes.vue?vue&type=script&lang=js&"
export * from "./PackageTypes.vue?vue&type=script&lang=js&"
import style0 from "./PackageTypes.vue?vue&type=style&index=0&id=98e9d204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e9d204",
  null
  
)

/* custom blocks */
import block0 from "./PackageTypes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports